import React from "react";
import {
  Countertops as CountertopsIcon,
  Diamond as DiamondIcon,
  LocalFireDepartment as HeatIcon,
  Shield as ShieldIcon,
} from "@mui/icons-material";
import CategoryPageTemplate from "../CategoryPageTemplate";
import { graniteCategories } from "./graniteData";

const GranitePage: React.FC = () => {
  const features = [
    { icon: CountertopsIcon, text: "Premium Natural Stone" },
    { icon: DiamondIcon, text: "Scratch Resistant" },
    { icon: HeatIcon, text: "Heat Resistant" },
    { icon: ShieldIcon, text: "25 Year Warranty" },
  ];

  return (
    <CategoryPageTemplate
      title="Granite Collection"
      subtitle="Premium Natural Stone Surfaces"
      description="Discover our exquisite granite collection featuring natural stone slabs for countertops, vanities, and surfaces. Each granite piece offers unique patterns, exceptional durability, and timeless beauty for your spaces."
      categoryData={graniteCategories}
      categoryType="Granite"
      gradientCategory="Granite"
      icon={CountertopsIcon}
      features={features}
    />
  );
};

export default GranitePage;
